// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".party_list_com .list_footer[data-v-7b4efc2e]{margin-top:1.09375rem;margin-right:1.041667rem;text-align:right}[data-v-7b4efc2e] .el-button{margin-left:.520833rem}", ""]);
// Exports
module.exports = exports;
